import { config } from '@iheartjane/config';

import { ApiRequestError } from '@jane/shared/data-access';

import type { SessionProps } from './authentication.types';

export const kioskAuthenticationMutationKeys = {
  deviceGrant: () => ['kiosk', 'device', 'grant'],
};

export const kioskAuthenticationQueryKeys = {
  deviceSession: (props?: SessionProps) =>
    props?.deviceCode
      ? ['kiosk', 'device', 'session', props.deviceCode]
      : ['kiosk', 'device', 'session'],
  kioskUser: () => ['kiosk', 'user'],
};

/** 422 means the device code is dead ("code is invalid" or "code has expired"); 400 means keep polling. */
const DEAD_DEVICE_CODE_MESSAGES = ['code is invalid', 'code has expired'];

export const isDeviceCodeRejected = (error: unknown) =>
  error instanceof ApiRequestError &&
  error.response.status === 422 &&
  DEAD_DEVICE_CODE_MESSAGES.includes(error.message);

export const kioskAuthenticationUrls = {
  deviceGrantBeginAuth: () =>
    `${config.apiPath}/kiosk/device_grants/begin_auth_session_via_qr`,
  deviceSession: () => `${config.apiPath}/kiosk/device_grants/sessions`,
  mfa: () => `${config.apiPath}/kiosk/users/multifactor_codes`,
  deviceAuthorization: () =>
    `${config.apiPath}/kiosk/device_grants/authorizations`,
  userSessions: () => `${config.apiPath}/kiosk/users/sessions`,
};
